import styled, { css } from "styled-components";
import { space, SpaceProps } from "styled-system";

const disabledProps = css`
    opacity: 0.6;
    pointer-events: none;
`;

export const Wrapper = styled.div<SpaceProps & { isEnabled?: boolean }>`
    ${space};

    ${p => p.isEnabled === false && disabledProps}

    margin: 8px 0;
`;

export const Label = styled.label`
    position: relative;
    display: flex;
    align-items: center;
    height: 32px;
    cursor: pointer;
    width: 100%;
    font-size: 13px;
    font-weight: 300;
    color: ${p => p.theme.fgColorDark};

    input {
        opacity: 0;
        width: 0;
        height: 0;
    }
`;

interface BoxProps {
    checked?: boolean;
    isEnabled?: boolean;
    flat?: boolean;
}

export const Box = styled.div<BoxProps>`
    margin-right: 8px;
    height: 16px;
    width: 16px;
    flex-shrink: 0;
    background-color: ${p => (p.checked ? p.theme.b400 : p.theme.n0)};
    transition: fill ${p => p.theme.transitionBase};
    border-style: ${p => (p.checked ? "none" : "solid")};
    border-color: ${p => p.theme.n500A};
    border-width: 1px;
    border-radius: 3.5px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${p =>
        !p.isEnabled && {
            backgroundColor: p.checked ? p.theme.b300 : p.theme.n0,
            borderColor: p.theme.n300A,
        }}
    ${p =>
        p.flat && {
            backgroundColor: p.checked ? p.theme.b400 : p.theme.n300A,
            borderColor: p.theme.n300A,
        }}

    ${p =>
        !p.checked &&
        css`
            &:hover {
                background-color: ${({ theme }) => theme.n400A};
                border-color: ${({ theme }) => theme.n400A};
                border-style: solid;
            }
        `}
`;

export const Check = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.84199 11.5072C6.53693 11.832 6.04414 11.832 5.73907 11.5072L2.93094 8.51777C2.62588 8.19301 2.62588 7.6684 2.93094 7.34364C3.23601 7.01888 3.7288 7.01888 4.03386 7.34364L6.28662 9.74187L11.6682 4.01277C11.9733 3.68801 12.4661 3.68801 12.7711 4.01277C13.0762 4.33753 13.0762 4.86214 12.7711 5.1869L6.84199 11.5072Z"
            fill="white"
            stroke="none"
        />
    </svg>
);

export const Hint = styled.div`
    font-size: 11px;
    font-weight: 300;
    color: ${p => p.theme.fgColorMedium};
`;
